import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// Entry point for the triage dashboard SPA.
//
// Mounts the React app into the `<div id="root">` declared in
// dashboard/index.html. Everything else — routing, auth guards, data
// fetching — is driven by src/App.tsx and its children.
//
// StrictMode is enabled so React runs effects twice in development to
// surface side-effect bugs early. It has no effect on the production
// build.

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error(
    "dashboard: #root element missing from index.html — build artifacts are corrupted",
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
